import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import InstallPWA from '../components/InstallPWA';

export default function Login() {
  const { loginBusiness, loginAdmin, user } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [adminEmail, setAdminEmail] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    if (user) navigate(user.role === 'admin' ? '/admin' : '/business', { replace: true });
  }, [user]);

  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    setIsPWA(!!isStandalone);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim()) { setError('Por favor ingresa tu usuario'); return; }
    setLoading(true); setError('');
    try {
      await loginBusiness(username.trim());
      navigate('/business', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally { setLoading(false); }
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    if (!adminEmail.trim() || !adminPassword.trim()) { setError('Completa todos los campos'); return; }
    setLoading(true); setError('');
    try {
      await loginAdmin(adminEmail.trim(), adminPassword.trim());
      setShowAdminModal(false);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally { setLoading(false); }
  };

  const APP_URL = window.location.origin;

  return (
    <div className="login-container">
      <div className="login-scroll">
        <div className="login-logo">
          <img src="/tuki-logo.svg" alt="TUKI" />
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          <input
            className="input"
            placeholder="Usuario de acceso"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoCapitalize="off"
          />
          {error && !showAdminModal && <p className="error-text">{error}</p>}
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Cargando...' : 'Iniciar Sesión'}
          </button>

          {!isPWA && (
            <InstallPWA />
          )}
        </form>

        <div className="login-footer" onClick={() => { setError(''); setShowAdminModal(true); }}>
          Propiedad intelectual de Winco Agencia
        </div>
      </div>

      {/* Admin Modal */}
      {showAdminModal && (
        <div className="modal-overlay" onClick={() => setShowAdminModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Acceso Administrador</h3>
            <form onSubmit={handleAdminLogin}>
              <input className="input" placeholder="Email" type="email" value={adminEmail}
                onChange={e => setAdminEmail(e.target.value)} autoCapitalize="off" />
              <input className="input" placeholder="Contraseña" type="password" value={adminPassword}
                onChange={e => setAdminPassword(e.target.value)} />
              {error && <p className="error-text">{error}</p>}
              <div className="modal-buttons">
                <button type="button" className="btn-secondary" onClick={() => { setShowAdminModal(false); setError(''); }}>Cancelar</button>
                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Cargando...' : 'Ingresar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
